"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.noCopyAndPaste = void 0;
/* ========================================================================
    Module: No copy and paste
 ========================================================================== */
/**
 * コピー & ペーストを禁止する
 *
 * @returns {void}
 */
const noCopyAndPaste = () => {
    const inputElements = document.querySelectorAll(".js-no-copy-and-paste");
    inputElements.forEach((element) => {
        ["copy", "paste", "contextmenu"].forEach((eventName) => {
            element.addEventListener(eventName, (e) => {
                e.preventDefault();
            }, true);
        });
    });
};
exports.noCopyAndPaste = noCopyAndPaste;
